import { render, staticRenderFns } from "./EditorHeaderWrapperPPT.vue?vue&type=template&id=aa43775e&scoped=true&"
import script from "./EditorHeaderWrapperPPT.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderWrapperPPT.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderWrapperPPT.vue?vue&type=style&index=0&id=aa43775e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa43775e",
  null
  
)

export default component.exports